// assets
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';

const icons = { DashboardOutlined, ClockCircleOutlined };

// ==============================|| MENU ITEMS - CLINICAL HEAD ||============================== //

// `catalogueCode` ties an item to its Features and Pages feature (rbac_app_feature.code),
// matched by CODE rather than URL so switching that feature off in the admin catalogue
// hides it here regardless of this role's URL prefix. See menu-items/catalogueVisibility.js.
const clinicalhead = {
  id: 'group-clinicalhead',
  title: 'Clinical Head',
  icon: icons.DashboardOutlined,
  type: 'group',
  children: [
    {
      id: 'clinicalhead-dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/clinicalhead/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false,
      catalogueCode: 'dashboard_reports'
    },
    {
      id: 'clinicalhead-coming-soon',
      title: 'Coming Soon',
      type: 'item',
      url: '/clinicalhead/coming-soon',
      icon: icons.ClockCircleOutlined,
      breadcrumbs: false
    }
  ]
};

export default clinicalhead;
